import {
  createSystemStatusReport,
  createSystemStatusReportSuccess,
  getFeedbackAnalytics,
  getFeedbackAnalyticsSuccess,
  getFeedbacks,
  getFeedbacksSuccess,
  getIssues,
  getIssuesSuccess,
  getSystemReports,
  getSystemReportsFailure,
  getSystemReportsSuccess,
  markBugReportsViewedSuccess,
  togglePublishAllSystemStatusReport,
  togglePublishAllSystemStatusReportSuccess
} from './system-status.actions';
import { createReducer, on } from '@ngrx/store';
import { initialSystemStatusState } from './system-status.state';

export const reducer = createReducer(
  initialSystemStatusState,

  on(getIssues, (state) => ({
    ...state,
    loading: true
  })),
  on(getIssuesSuccess, (state, { issues }) => ({
    ...state,
    issues: issues,
    loading: false
  })),
  on(getFeedbacks, (state) => ({
    ...state,
    loading: true
  })),
  on(getFeedbacksSuccess, (state, { feedbacks }) => ({
    ...state,
    feedbacks,
    loading: false
  })),
  on(getSystemReports, (state) => ({
    ...state,
    systemReportsStatus: 'loading' as const,
    loading: true
  })),
  on(getSystemReportsSuccess, (state, { systemReports }) => ({
    ...state,
    systemReports: systemReports,
    systemReportsStatus: 'loaded' as const,
    loading: false
  })),
  // The handler that was missing. Previously a failed load left the status at
  // its initial value and the reports list empty, which the page rendered as
  // "All Systems Operational" while the backend was unreachable.
  on(getSystemReportsFailure, (state) => ({
    ...state,
    systemReportsStatus: 'unavailable' as const,
    loading: false
  })),
  on(createSystemStatusReport, (state) => ({
    ...state,
    loading: true
  })),
  on(createSystemStatusReportSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(togglePublishAllSystemStatusReport, (state) => ({
    ...state,
    loading: true
  })),
  on(togglePublishAllSystemStatusReportSuccess, (state) => ({
    ...state,
    loading: false
  })),
  on(markBugReportsViewedSuccess, (state, { issues }) => ({
    ...state,
    issues: state.issues.map((item) => {
      return {
        ...item,
        isviewed: issues.some((i) => i.id === item.id) || item.isviewed
      };
    })
  })),
  on(getFeedbackAnalytics, (state) => ({
    ...state,
    loading: true
  })),
  on(getFeedbackAnalyticsSuccess, (state, { analytics }) => ({
    ...state,
    analytics,
    loading: false
  }))
);
